module.exports = __webpack_public_path__ + "img/fi-rr-list-check.1a5cbc9e.svg";